import React, { useState } from "react";

import { rescheduleSchema } from "../schemas/followup";

interface RescheduleModalProps {
  companyName: string;
  currentDueDate: string;
  onConfirm: (dueDate: string) => Promise<void>;
  onCancel: () => void;
}

export function RescheduleModal({
  companyName,
  currentDueDate,
  onConfirm,
  onCancel,
}: RescheduleModalProps) {
  const [dueDate, setDueDate] = useState(currentDueDate);
  const [fieldError, setFieldError] = useState<string | null>(null);
  const [formError, setFormError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setFormError(null);

    const result = rescheduleSchema.safeParse({ due_date: dueDate });
    if (!result.success) {
      setFieldError(result.error.flatten().fieldErrors.due_date?.[0] ?? null);
      return;
    }
    setFieldError(null);

    setIsSubmitting(true);
    try {
      await onConfirm(result.data.due_date);
    } catch {
      setFormError("Não foi possível reagendar. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/30">
      <div className="w-full max-w-sm rounded-[10px] border border-border-subtle bg-white p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-800">Reagendar follow-up</h2>
        <p className="mt-1 text-sm text-slate-500">
          Nova data para o follow-up com {companyName}.
        </p>

        <form className="mt-4" onSubmit={handleSubmit}>
          <label htmlFor="due_date" className="block text-sm font-medium text-slate-700">
            Nova data
          </label>
          <input
            id="due_date"
            type="date"
            value={dueDate}
            onChange={(event) => setDueDate(event.target.value)}
            className="mt-1 block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
          {fieldError && <p className="mt-1 text-sm text-red-600">{fieldError}</p>}
          {formError && <p className="mt-1 text-sm text-red-600">{formError}</p>}

          <div className="mt-4 flex justify-end gap-2">
            <button
              type="button"
              onClick={onCancel}
              className="rounded-[10px] px-4 py-2 text-sm font-medium text-slate-600 hover:bg-surface"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="rounded-[10px] bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark disabled:opacity-60"
            >
              {isSubmitting ? "Salvando..." : "Confirmar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
